import { REPORT_CONTROL_TYPES } from '../../InSpectionReport.constant'
import './Checkpoints.style.less'
import ControlTypePhoto from './ControlType/ControlTypePhoto'
import ControlTypeMultiSelect from './ControlType/ControlTypeMultiSelect'
import ControlTypeSelect from './ControlType/ControlTypeSelect'
import ControlTypeSelectDropdown from './ControlType/ControlTypeSelectDropdown'
import ControlTypeDate from './ControlType/ControlTypeDate'
import ControlTypeText from './ControlType/ControlTypeText'
import ControlTypeGroup from './ControlType/ControlTypeGroup'
import ControlTypeEditableEntryList from './ControlType/ControlTypeEditableEntryList'
interface Props {
  data: any
  user: any
  editable: boolean
  onEditPhoto: (photoIndex: number) => void
  onAddPhoto: () => void
  subSectionTemplate: any
  reportType: string
  templateSections?: Array<any>
  sectionName?: string
  subsectionName?: string
  editComponent: any
  addNewPhotoButton: any
  section: {
    section: any
    sectionIndex: number
  }
  subSection: {
    subSection: any
    subSectionIndex: number
  }
  checkpoint?: any
  options?: any
}

function Checkpoints(props: Props) {
  const { data, editComponent, addNewPhotoButton } = props
  const { control_type } = data

  const {
    TEXT,
    NUMBER,
    INTEGER,
    DATE,
    PHOTO,
    SELECT,
    SELECT_DROPDOWN,
    MULTI_SELECT,
    GROUP,
    EDITABLE_ENTRY_LIST,
  } = REPORT_CONTROL_TYPES

  function RenderComponent() {
    switch (control_type) {
      case PHOTO:
        return (
          <ControlTypePhoto
            data={data}
            editable={props.editable}
            onEditPhoto={props.onEditPhoto}
            onAddPhoto={props.onAddPhoto}
            section={props.section}
            subSection={props.subSection}
            checkpoint={props.checkpoint}
            options={props.options}
          />
        )
      case MULTI_SELECT:
        return (
          <ControlTypeMultiSelect data={data} editComponent={editComponent} />
        )
      case SELECT:
        return <ControlTypeSelect data={data} editComponent={editComponent} />
      case SELECT_DROPDOWN:
        return (
          <ControlTypeSelectDropdown
            data={data}
            editComponent={editComponent}
          />
        )
      case DATE:
        return <ControlTypeDate data={data} editComponent={editComponent} />
      case TEXT:
      case NUMBER:
      case INTEGER:
        return (
          <ControlTypeText
            data={data}
            sectionName={props.sectionName}
            subsectionName={props.subsectionName}
            reportType={props.reportType}
            editComponent={editComponent}
          />
        )
      case EDITABLE_ENTRY_LIST:
        return (
          <ControlTypeEditableEntryList
            data={data}
            editComponent={editComponent}
          />
        )
      case GROUP:
        return (
          <ControlTypeGroup
            data={data}
            template={props.subSectionTemplate}
            reportType={props.reportType}
            templateSections={props.templateSections}
            subsectionName={data.name}
            sectionName={props.sectionName}
            editComponent={editComponent}
            addNewPhotoButton={addNewPhotoButton}
          />
        )
      default:
        return <div />
    }
  }

  return <RenderComponent />
}

export default Checkpoints
